import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const OffTheGrid = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize("tablet720")}) {
        justify-content: flex-end;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query HowItWorksOffTheGridHeroImageQuery {
          file(relativePath: { eq: "off_grid.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 18% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 25% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />

    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "default"
          )}) and (max-width: 479px) {
          padding: 32px 38px 35px 38px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 959px) {
          width: 378px;
        }
        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          padding: 32px 38px 34px 42px;
          width: 418px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          padding: 44px 48px 46px 50px;
          width: 479px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding: 74px 80px;
        }
      `}
    >
      <Header2>
        {"Off the Grid"}
        <Underlined
          css={`
            @media screen and (min-width: ${getSize("desktop1920")}) {
              margin-top: 21px;
            }
          `}
        />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "default"
            )}) and (max-width: 479px) {
            margin-top: 23px;
          }
          @media screen and (min-width: ${getSize(
              "mobile480"
            )}) and (max-width: 719px) {
            margin-top: 23px;
          }
          @media screen and (min-width: ${getSize(
              "tablet720"
            )}) and (max-width: 959px) {
            margin-top: 22px;
          }
          @media screen and (min-width: ${getSize(
              "tablet960"
            )}) and (max-width: 1919px) {
            margin-top: 23px;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            margin-top: 22px;
          }
        `}
      >
        {
          "Create customized Virtual Critical Load panels to fit your situation. Decide how the system reacts to a grid outage based on time of day, season, or custom triggers. You decide what circuits are critical at any given time, and you can add or subtract loads as required. Set an energy budget and stay within it."
        }
      </Paragraph>
    </Card>
  </Section>
);
